import React from "react";
import { withStyles, createStyles, WithStyles, Theme } from "@material-ui/core/styles";
import Grid from "../../../lib/components/grid";
import { GridColumns } from "./gridsetup";
import { getFinancialYearSelected } from "../../../lib/api/week";
import { Row } from "react-data-grid";
import { producerAdjustmentSummary } from "../../../lib/api/producersfullinvoice";

const styles = (theme: Theme) =>
  createStyles({
    root: {},
  });

type Props = { history: any } & WithStyles<typeof styles>;

class ProducerAdjustmentSummaryUnstyled extends React.Component<Props, {}> {
  constructor(props) {
    super(props);
  }

  state = {
    loading: true,
    data: [],
  };

  componentDidMount() {
    this.loadData();
  }

  loadData = async () => {
    this.setState({ loading: true });
    const resp = await producerAdjustmentSummary(getFinancialYearSelected());
    this.setState({ loading: false, data: resp });
  };

  handleSelectProducer = (producercode: string) => {
    this.props.history.push(`/producers/adjustments/${producercode}`);
  };

  rowRenderer = (props) => {
    const { row } = props;
    return <Row {...props} onDoubleClick={() => this.handleSelectProducer(row.producercode)} />;
  };

  render() {
    return (
      <div>
        <Grid
          loading={this.state.loading}
          clearFilters="adjustmentproducerinvoicesummary"
          data={this.state.data}
          GridColumns={GridColumns}
          rowRenderer={this.rowRenderer}
          totalRowColumns={["noCartonsTotal", "saleTotal", "amountCreditTotal", "amountDebitTotal"]}
        />
      </div>
    );
  }
}

export default withStyles(styles)(ProducerAdjustmentSummaryUnstyled);
